import { GuestStatus } from 'src/app/samwebDescription/samwin/GuestStatus';
import { ChatDetails } from './chat-details';

export class ChatGuestInfo {
   public chat: ChatDetails;
   public guestStatus: GuestStatus;

   public constructor(details: ChatDetails, status: GuestStatus) {
      this.chat = details;
      this.guestStatus = status;
   }
}
